import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space["space-1"]};
`;

export const InfoContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const BetContainer = styled.div`
  display: flex;
  &:not(:empty) {
    margin-left: ${({ theme }) => theme.space["space-1"]};
  }
`;
